import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Modal, Alert, Fade } from 'react-bootstrap';
import { actions } from 'react-redux-form';
import { clickLogout } from '../../actions/auth';

class Comp extends Component {
  constructor(prop) {
    super(prop);
    this.close = this.close.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
  }
  close() {
    const { dispatch } = this.props;
    dispatch(actions.change('forms.showLogoutModal', false));
    this.setState({
      showModal: false,
    });
  }
  handleLogout() {
    const { dispatch } = this.props;
    dispatch(clickLogout());
    dispatch(actions.change('forms.showLogoutModal', false));
  }
  render() {
    const { forms } = this.props;

    return (
      <Fade in={forms.showLogoutModal} unmountOnExit={true} appear={true}>
        <div className="modal-open">
          <div className="fade modal-backdrop in" />
          <Modal.Dialog>
            <Modal.Header closeButton onHide={() => this.close()}>
              <Modal.Title>未送出のデータがあります。</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Alert bsStyle="warning">
                このままログアウトすると学習進捗などの情報が失われてしまう可能性があります。通信環境を確認して再度ログアウトを試みることをお勧めします。
              </Alert>
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={() => this.close()}>キャンセル</Button>
              <Button onClick={() => this.handleLogout()} bsStyle="primary">
                ログアウトする
              </Button>
            </Modal.Footer>
          </Modal.Dialog>
        </div>
      </Fade>
    );
  }
}

export default connect((s) => s)(Comp);



// WEBPACK FOOTER //
// ./src/components/layout/LogoutModal.js